module.exports = __webpack_public_path__ + "img/teacher-winner-vi-VN.99c01238.png";